import { ReactNode, useEffect } from "react";
import { RouteConstant } from "../util/constant/RouteConstant";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/store/modules";
import { auth } from "@/store/modules/auth.ts";
import { base } from "@/store/modules/base.ts";
import {
  AlignVerticalSpaceAround,
  Bell,
  BrainCog,
  LayoutDashboard,
  LogOut,
  RefreshCcw,
  User,
} from "lucide-react";

function SvgImage() {
  return (
    <div className="dp">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        aria-hidden="true"
        role="img"
        className="iconify iconify--ic"
        width="1.3rem"
        height="1.3rem"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 24 24"
      >
        {" "}
        <path
          fill="currentColor"
          d="M10 8.64L15.27 12L10 15.36V8.64M8 5v14l11-7L8 5z"
        ></path>
      </svg>
    </div>
  );
}

type DropdownProps = {
  title: string;
  list: { name: string; nextRoute: string }[];
};

function Dropdown({ title, list }: DropdownProps) {
  const navigate = useNavigate();
  return (
    <div className="middle-side-nav">
      <div className="dropdown-toggle">
        <SvgImage />
        {/*display: "flex", justifyContent: "space-between", width: "100%"*/}
        <div style={{ display: "flex", gap: ".5rem" }} className="drop-head">
          {title}
          <h6
            style={{
              fontSize: "7px",
              marginTop: ".2rem",
              color: "red",
              lineHeight: 0.9,
            }}
          >
            coming
            <br />
            soon...
          </h6>
        </div>
      </div>
      {/*${"active" : ""}*/}
      <nav className={`dropdown-list list1`}>
        {list.map((item, index) => (
          <p
            key={index}
            className="dropdown-link-4 nav-link"
            onClick={() => navigate(item.nextRoute)}
          >
            {item.name}
          </p>
        ))}
      </nav>
    </div>
  );
}

export type DashboardLayoutType = {
  children: ReactNode;
};
export default function DashboardLayout({ children }: DashboardLayoutType) {
  const authState = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(base.mutation.resetModalOptions());
  }, []);

  useEffect(() => {
    const stylesheets = [
      "/assets/css/normalize.css",
      "/assets/css/qunity-web.webflow.css",
      "/assets/css/webflow.css",
      "/assets/css/App.css",
    ];
    const links = stylesheets.map((href) => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      document.head.appendChild(link);
      return link;
    });

    return () => {
      links.forEach((link) => document.head.removeChild(link));
    };
  }, []);

  function handleLogout() {
    dispatch(base.mutation.setBaseLoading(true));
    setTimeout(() => {
      dispatch(auth.mutation.setToken(null));
      dispatch(base.mutation.resetModalOptions());
      dispatch(base.mutation.setBaseLoading(false));
      dispatch(auth.action.logout());
      navigate(RouteConstant.auth.login.path);
    }, 500);
  }

  const handleRefresh = () => {
    window.location.reload();
  };
  return (
    <>
      <div style={{ display: "flex", gap: "30rem" }}>
        <section className="bg-black w-full px-10 fixed z-50">
          <div className="navwrapper">
            <div className="topleft-nav h-20">
              <div>
                <img src="/svgs/logo.svg" loading="lazy" alt="" />
              </div>
              <div className="search-wrapper">
                {/* <input
                  className="search-topnav w-input"
                  maxLength={256}
                  name="field-2"
                  data-name="Field 2"
                  placeholder="Search"
                  type="text"
                  id="field-2"
                  required
                /> */}
                <div className="search-icon">
                  <i className="bx bx-search"></i>
                </div>
              </div>
            </div>
            <div style={{ display: "flex" }} className="text-white gap-2">
              <Bell className="size-6" />
              <div className="divider"></div>
              <RefreshCcw
                onClick={handleRefresh}
                className="size-6 hover:cursor-pointer"
              />
              <div className="divider"></div>
              <div className="">
                <div className="usercolor">
                  <span
                    className="flex-row text-lg flex"
                    style={{ color: "white" }}
                  >
                    {authState.userInfo.userFullName}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="sidebar justify-between  flex flex-col">
          <div>
            <div
              onClick={() => navigate(RouteConstant.dashboard.dashboard.path)}
              className="flex-col  hover:cursor-pointer  flex items-center"
            >
              <AlignVerticalSpaceAround className="size-20 hover:text-black text-secondary" />

              <div
                className="text-xl"
                style={{ display: "flex", color: "inherit" }}
              >
                WORKSPACE
              </div>
            </div>
            <button
              onClick={() => navigate("/integration")}
              className="flex-col mt-20  flex items-center"
            >
              <BrainCog className="size-20 hover:text-black  text-secondary" />
              <span
                style={{ fontSize: "1.3rem", color: "rgba(0, 0, 0, 0.56)" }}
              >
                Integration
              </span>
            </button>
            <button
              onClick={handleLogout}
              className="flex-col mt-20  flex items-center"
            >
              <LogOut className="size-20 hover:text-black  text-secondary" />
              <span
                className={""}
                style={{ fontSize: "1.3rem", color: "rgba(0, 0, 0, 0.56)" }}
              >
                Logout
              </span>
            </button>
          </div>
        </section>
      </div>
      {children}
    </>
  );
}
// <ul className={`dropdown ${isDropdownActive ? "active" : ""}`}>
//     <li className="top-divide">
//         <div className="profile">
//             <div className="user">
//                 <span>{authState.userInfo.userFullName}</span>
//                 <a href="#">
//                 Account</a>
//             </div>
//         </div>
//     </li>
//     <li className="bottom-li">My Account</li>
//     <li className="bottom-li">Account Settings</li>
//     <li className="bottom-li">Billings</li>
//     <li className="bottom-li">
//         <div className="logout-btn" onClick={gotoLogin}>
//             Log out
//         </div>
//     </li>
// </ul>
